'use strict';

(function (global) {

  // Идентификатор для хранения приватного свойства с jQuery-объектом вызываемой функции кнопки тулбара
  const toolbarButtonReverseActionPrivatePropertyKey = Symbol('action');
  
  /**
   * Переключаемая кнопка тулбара предпросмотра (с состоянием нажатости).
   *
   * @namespace window.Core.preview.toolbar
   * @since 5.7.0
   */
  class SelectableToolbarButton extends global.BaseToolbarButton {

    constructor(buttonSelector, mainAction, reverseAction) {
      super(buttonSelector, mainAction);
      this[toolbarButtonReverseActionPrivatePropertyKey] = reverseAction;
    }

    /**
     * Действие кнопки предпросмотра при нажатой кнопке.
     *
     * @private
     * @property _reverseAction
     * @return {function} Функция предпросмотра из пространства имён window.Core.preview.actions.
     */
    get _reverseAction() {
      return this[toolbarButtonReverseActionPrivatePropertyKey];
    }

    /**
     * Является ли кнопка нажатой
     *
     * @property isTurnedOn
     * @return {boolean} TRUE - если кнопка нажата, иначе - FALSE.
     */
    get isTurnedOn() {
      return this._jButton.hasClass('selected');
    }

    /**
     * @see BaseToolbarButton._performAction
     */
    _performAction() {
      const isTurnedOn = this.isTurnedOn;
      if (isTurnedOn) {
        this.turnOff();
      } else {
        this.turnOn();
      }

      const shouldCallDefaultAction = !isTurnedOn;
      this._toggleAction(shouldCallDefaultAction);
    }

    /**
     * Вызвать действие в зависимости от нажатости кнопки
     *
     * @method _toggleAction
     * @param {boolean} shouldCallDefaultAction TRUE - если нужно вызвать основное действие, FALSE - если дополнительное.
     */
    _toggleAction(shouldCallDefaultAction) {
      if (shouldCallDefaultAction) {
        this._action();
      } else if (this._reverseAction) {
        this._reverseAction();
      }
    }

    /**
     * Сделать кнопку нажатой (добавлением соответствующего класса)
     *
     * @method turnOn
     */
    turnOn() {
      this._jButton.addClass('selected');
    }

    /**
     * Сделать кнопку отжатой (убиранием соответствующего класса)
     *
     * @method turnOff
     */
    turnOff() {
      this._jButton.removeClass('selected');
    }

    /**
     * Вызвать состояние нажатости и соответствующее действия
     *
     * @method setSelectedStateAndPerformAction
     * @param {boolean} shouldBeTurnedOn TRUE - если кнопка должна быть нажата, иначе - FALSE.
     */
    setSelectedStateAndPerformAction(shouldBeTurnedOn) {
      if (shouldBeTurnedOn) {
        this.turnOn();
      } else {
        this.turnOff();
      }
      this._toggleAction(shouldBeTurnedOn);
    }
  }

  global.SelectableToolbarButton = SelectableToolbarButton;

})(window.Core.preview.toolbar);